module.exports = __webpack_public_path__ + "img/s-banner.9092c394.png";